import Api from "@/Api/Api";

const prefixURL = "/seguridad/auth";

export default {
  doLogin(params) {
    return Api().post(prefixURL + "/login", params);
  },

  doCambiarClave(params) {
    return Api().post(prefixURL + "/cambiarClave", params);
  },

  // Common Logout
  doLogout({ username }) {
    const fdata = new FormData();
    fdata.append("username", username);

    Api().post(prefixURL + "/logout", fdata);
  },

  doRegistrarse(params) {
    return Api().post(prefixURL + "/registrarse", params);
  },

  doOlvidoClave(params) {
    return Api().post(prefixURL + "/olvidoclave", params);
  },

  doRecuperarClave(params) {
    return Api().post(prefixURL + "/recuperarclave", params);
  },
  doCargarMenu(params) {
    return Api().post(prefixURL + "/cargarMenu", params);
  },
};
